import { VOICE_MESSAGE_SUB_TYPE } from '../model/constants'

type VoiceMessageSource = {
  subType?: typeof VOICE_MESSAGE_SUB_TYPE
}

export const isVoiceMessage = (item?: VoiceMessageSource | null): boolean => {
  return item?.subType === VOICE_MESSAGE_SUB_TYPE
}
